// extracted by mini-css-extract-plugin
module.exports = {"OrderButton":"style-module--OrderButton--3bk53","disable":"style-module--disable--bMQmQ"};